var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4513 13.4883V7.26137C13.4513 7.18101 13.5177 7.11586 13.5994 7.11586H14.5013C14.583 7.11586 14.6494 7.18101 14.6494 7.26137V14.1432C14.6494 14.4331 14.4119 14.6667 14.1171 14.6667H1.86555C1.57079 14.6667 1.33325 14.4331 1.33325 14.1432L1.33325 2.09222C1.33325 1.80233 1.57079 1.56871 1.86555 1.56871L8.16529 1.56871C8.23985 1.56871 8.2988 1.62839 8.2988 1.70001V2.61743C8.2988 2.68906 8.23812 2.74874 8.16529 2.74874L2.53136 2.74874L2.53136 13.4883H13.4513Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1302 3.71195L7.21913 9.8258C7.16518 9.87885 7.0769 9.87884 7.02297 9.82577L6.33649 9.15043C6.28255 9.09737 6.28257 9.01055 6.33652 8.95751L12.2476 2.84365L11.316 1.92711C11.2338 1.84631 11.2817 1.70765 11.3982 1.69441L14.5111 1.33434C14.532 1.33183 14.5532 1.33404 14.5731 1.34079C14.593 1.34754 14.6111 1.35866 14.626 1.37331C14.6409 1.38795 14.6522 1.40573 14.659 1.42531C14.6659 1.44488 14.6681 1.46574 14.6656 1.48629L14.2985 4.54773C14.2862 4.66107 14.144 4.70928 14.0619 4.62848L13.1302 3.71195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/Leave.a16c5b1f1ce9c35c68054b63f630152e.svg";
export { ForwardRef as ReactComponent };